<template>
<div class="course-list-group">
    <div class="course-list" v-for="(item, index) in currentScheduleList" :key="item.startTime">
        <h4 class="list-title" v-if="index === 0">
            {{ item.startDateStr }}
            <span>{{ currentScheduleList.length }}次课</span>
        </h4>
        <div class="course-student">
            <div>
                <!-- <img :src="item.teacherAvatar" alt="👱"> -->
                <div class="student">
                    <p>{{ item.teacherFamilyName }}老师
                        <span :class="{ audition: item.lessonType === 1 }" v-if="item.lessonType === 1">试听</span>
                        <span v-else-if="item.lessonType === 2">正式</span>
                        <span :class="{ answering: item.lessonType === 3 }" v-else>答疑</span>
                    </p>
                </div>
            </div>
            <div class="course-time">
                <i></i>
                {{ `${item.startDateStr} ${item.startHourStr} ~ ${item.endHourStr}` }}
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        currentScheduleList: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="scss" scoped>
.course-list {
    // border-bottom: 1px solid #eee;
    // margin: 0 30px;
    padding: 10px 0;

    img {
        border-radius: 50%;
        width: 38px;
        height: 38px;
        background: green;
        vertical-align: middle;
    }
}

.list-title {
    margin: 30px 0;
    color: #000;
    font-size: 16px;

    span {
        margin-left: 5px;
    }
}

.course-student {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    background: #fff;
    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    padding: 0 26px;
    position: relative;

    &::before {
        display: block;
        content: '';
        position: absolute;
        width: 4px;
        height: 20px;
        left: 0;
        background: #9171dd;
        border-radius: 15px;
    }
}

.student {
    display: inline-block;

    p:first-of-type {
        font-size: 14px;
        color: #333;

        span {
            font-size: 12px;
            width: 38px;
            height: 16px;
            background: rgba(45, 189, 114, 0.1);
            line-height: 16px;
            text-align: center;
            padding: 2px 4px;
            margin-left: 10px;
            color: #2dbd72;
            border-radius: 0 8px;
        }

        span.audition {
            background: rgba(145, 113, 221, 0.1);
            color: #9171dd;
        }

        span.answering {
            background: rgba(255, 132, 83, 0.1);
            color: #ff8453;
        }
    }

    p:last-of-type {
        font-size: 18px;
        color: #54423d;
        font-weight: 700;
    }
}

.course-time {
    font-size: 12px;
    color: #998a87;
    height: 38px;
    line-height: 38px;
    position: relative;

    i {
        background: url(../../../assets/images/course/time_default.png) no-repeat center;
        background-size: contain;
        width: 11px;
        height: 11px;
        position: absolute;
        left: -15px;
        top: 13px;
    }
}

.course-list-group {
    padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/CourseScheduleList.vue